module.exports = __webpack_public_path__ + "static/media/google_play_es.6bb864c3.png";